import Phaser from 'phaser';
import MenuScene from './MenuScene';

/** Placeholder boot scene. Real texture atlases land here later. */
export default class BootScene extends Phaser.Scene {
  constructor() {
    super('Boot');
  }

  create(): void {
    // MVP uses Graphics + Text only; no binary assets yet.
    this.scene.start(MenuScene.key);
  }
}
